// extracted by mini-css-extract-plugin
export default {"container":"History_container__n5VRL","left":"History_left__TrQTQ","description":"History_description__D5ygT","info":"History_info__IqemS"};